import { liveHelperRender } from '@liveHelper/liveHelperRender'
import { LIVE_HELPER_ELEMENT_ID } from '@oneToOne/shared/components/chat/constants'
import { create, cssomSheet } from 'twind'

import { ensureConstructableStylesheetsSupport } from '@core/polyfills/cssStyleSheet'
import { pixelFontSize, pixelLineHeight, pixelSpacing } from '@core/twind'
import { pixelBorderRadius } from '@core/twind/theme'

import 'construct-style-sheets-polyfill'

import { FWNElement } from './bases/FWNElement'

declare module 'react' {
  // eslint-disable-next-line @typescript-eslint/no-namespace
  namespace JSX {
    interface IntrinsicElements {
      [LIVE_HELPER_ELEMENT_ID]: Record<string, string | boolean>
    }
  }
}

ensureConstructableStylesheetsSupport().then(() => {
  const sheet = cssomSheet({ target: new CSSStyleSheet() })
  const { tw } = create({
    sheet,
    theme: {
      spacing: pixelSpacing,
      fontSize: pixelFontSize,
      lineHeight: pixelLineHeight,
      borderRadius: pixelBorderRadius,
    },
  })

  class LiveHelperElement extends FWNElement {
    override createRenderRoot() {
      super.createRenderRoot()

      if (this.shadowRoot) {
        this.shadowRoot.adoptedStyleSheets = [sheet.target]
      }
    }

    override render(): void {
      if (this.shadowRoot) {
        liveHelperRender({
          target: this.shadowRoot,
          widgetId: this.widgetId,
          widgetAttributes: this.getAttributes(),
          tw,
        })
      }
    }
  }

  if (!customElements.get(LIVE_HELPER_ELEMENT_ID)) {
    customElements.define(LIVE_HELPER_ELEMENT_ID, LiveHelperElement)
  }
})
